export const nl = {
  save: 'bewaar',
  delete: 'verwijder',
  edit: 'wijzig',
  cancel: 'annuleer',
  new: 'nieuw',
  'delete-confirm': 'weet je zeker dat je dit wil verwijderen?',
  previous: 'vorige',
  next: 'volgende',
  show: 'toon',
  to: 'tot',
  from: 'van',
  results: 'resultaten',
  hide: 'verberg',
  filters: 'filters',
  filter: 'filter',
  'select-option': 'selecteer een optie',
  'remove-selection': 'verwijder selectie',
  'delete-this': 'verwijder dit',
  'upload-file': 'upload een bestand',
  'upload-another-file': 'upload nog een bestand',
  'up-to': 'tot',
  'select-one': 'selecteer',
}
